// extracted by mini-css-extract-plugin
export default {"container":"_5wpvXXs0NCC5QCiGdgp3hy","icon":"_2kIgjRzHKHyUWGX6bfkAbl"};